import React from 'react';

import cx from 'classnames';
import { isEmpty } from 'lodash';

import { SupportTextProps } from './types';

import styles from './input.module.scss';

interface SupportTextSectionProps extends SupportTextProps {
  maxLength?: number;
  showCharCount?: boolean;
}

const SupportTextSection = (props: SupportTextSectionProps) => {
  const { text, className, maxLength, showCharCount, status = 'default' } = props;

  if (isEmpty(text) && !showCharCount) return null;

  return (
    <section className={cx(styles.supportTextContainer)}>
      {!isEmpty(text) && (
        <p
          className={cx(
            styles.supportText,
            {
              [styles.default]: status === 'default',
              [styles.error]: status === 'error',
              [styles.success]: status === 'success',
              [styles.warning]: status === 'warning',
            },
            className,
          )}
        >
          {text}
        </p>
      )}
      {showCharCount && <p className={styles.characterCount}>{maxLength}</p>}
    </section>
  );
};

export default SupportTextSection;
